import React from "react";

const DisplayComponent = ({ from, to, totalRows }) => {
  return (
    <div>
      <p className={`text-[13px] text-black`}>
        {`Showing`} <span className="font-medium">{from}</span> {`to`}{" "}
        <span className="font-medium">{to}</span> {`out of`}{" "}
        <span className="font-medium">{totalRows}</span> {`results`}
      </p>
    </div>
  );
};

export default DisplayComponent;
